import Abstract from "../../abstract-view/abstract.js";

export default class ResultsWrapper extends Abstract {
  constructor(element) {
    super();

    this._element = element;
    this._parentElement = null;
  }

  getParent() {
    if (!this._parentElement) {
      this._parentElement = this._element.parentElement;
    }

    return this._parentElement;
  }

  setParentHeight() {
    this.getParent().style.height = `${this.getParent().offsetHeight}px`;
  }

  resetParent() {
    this.getParent().style.height = null;
  }
}
